import { createFileRoute } from "@tanstack/react-router";
import WhatIsSaintTmsGoogle from "@/pages/WhatIsSaintTmsGoogle";
export const Route = createFileRoute("/what-is-saint-tms-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "What Is SAINT® TMS? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What is SAINT® TMS? FDA-cleared 5-day fMRI-guided accelerated TMS for depression at Neuro Wellness in Coral Springs, FL. Free consultation available.",
        },
        {
          property: "og:title",
          content: "What Is SAINT® TMS? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What is SAINT® TMS? FDA-cleared 5-day fMRI-guided accelerated TMS for depression at Neuro Wellness in Coral Springs, FL. Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/what-is-saint-tms-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-is-saint-tms-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatIsSaintTmsGoogle />;
}
